export const _account = [
  {
    label: 'My profile',
    href: '/personal-settings/profile',
  },
  {
    label: 'Change password',
    href: '/personal-settings/change-password',
  },
  {
    label: 'Logout',
    href: '',
  },
];
